import { render } from "./ParceirosView.vue?vue&type=template&id=12e3028e&scoped=true"
import script from "./ParceirosView.vue?vue&type=script&lang=js"
export * from "./ParceirosView.vue?vue&type=script&lang=js"

import "./ParceirosView.vue?vue&type=style&index=0&id=12e3028e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e3028e"]])

export default __exports__